"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RegisterReportInfo = void 0;
var _LabelValueDisplay = _interopRequireDefault(require("01_core/components/layout/LabelValueDisplay"));
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 報告日と報告先
 */
const RegisterReportInfo = props => {
  const {
    intl,
    reportDate,
    reportDestNm
  } = props;
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_REPORT_DATE
    }),
    value: _stringUtil.default.emptyToHyphen(reportDate)
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_REPORT_NAME
    }),
    value: _stringUtil.default.emptyToHyphen(reportDestNm)
  })));
};
exports.RegisterReportInfo = RegisterReportInfo;
var _default = exports.default = (0, _reactIntl.injectIntl)(RegisterReportInfo);